import { SB } from '@play-co/replicant';

const piggyBankEntry = SB.object({
  /** Timestamp when this entry was created */
  createdAt: SB.int(),
  /** Gems accumulated in the bank */
  gemsAccumulated: SB.int(),
  /** Whether the bank has been broken (purchased) */
  broken: SB.boolean(),
  /** Eligibility segment locked in at entry creation: 'never_purchased' | 'lapsed_purchaser' | '' */
  segment: SB.string(),
});

export type PiggyBankEntry = SB.ExtractType<typeof piggyBankEntry>;

export const piggyBankSchema = {
  /** @deprecated Piggy Bank feature removed after A/B 0454 resolved to control. */
  piggyBank: SB.object({
    /** Map of events the user has participated in, keyed by event ID */
    entries: SB.map(piggyBankEntry),
    /** Timestamp when the intro popup was first shown (once per lifetime) */
    introSeenAt: SB.int().optional(),
  }),
};
